import type { ButtonHTMLAttributes } from "react";
import "./CameraShutter.css";

/** Camera capture keeps its familiar shutter target instead of a text action. */
const CameraShutter = ({
  className = "",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    type="button"
    {...props}
    className={`ds-camera-shutter ${className}`.trim()}
  >
    <span className="ds-camera-shutter__outer" aria-hidden="true">
      <span className="ds-camera-shutter__inner" />
    </span>
  </button>
);

export default CameraShutter;
